import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {//it contains packing materials details of an estimate.
    let IV2_PageDetails = useContext(RecordsManagementContext).IV2_PageDetails
    return (
        <table className="table">
            <thead>
            <tr>
                <th className="th-bost-new">PACKING SERVICE & MATERIALS</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td className="td-bost-new" >
                    {IV2_PageDetails.PackingMaterials.List.length > 0 ?
                        <table className='table small'>
                            <thead>
                            <tr>
                                <td>Items</td>
                                <td>QTY</td>
                                <td>Material Cost</td>
                                <td>Total</td>
                                <td>Pack QTY</td>
                                <td>Unpack QTY</td>
                            </tr>
                            </thead>
                            <tbody>
                            {IV2_PageDetails.PackingMaterials.List.map((PackingMaterial, key) => {
                                return (
                                    <tr key={'Tr' + key}>
                                        <td key={'Td1' + key}>{PackingMaterial.Name}</td>
                                        <td key={'Td2' + key}>{PackingMaterial.Qty}</td>
                                        <td key={'Td3' + key}>{PackingMaterial.Price}</td>
                                        <td key={'Td4' + key}>{PackingMaterial.TotalPrice}</td>
                                        <td key={'Td5' + key}>{PackingMaterial.PackQuantity}</td>
                                        <td key={'Td6' + key}>{PackingMaterial.UnpackQuantity}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table> : 'No records available'}
                </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
                <td className="th-bost-new">Total Packing & material charges: {IV2_PageDetails.PackingMaterials.TotalPrice}</td>
            </tr>
            </tfoot>
        </table>
    )
}